  <div class="row-new">
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="lob-headers">UCMG ID</p>
      </span>
      <p>
        <span class="edit-defaults demographics-lob-default-name">{{ucmgData?.UCMG_ID}}</span>
      </p>
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="lob-headers">UCMG Name</p>
      </span>
      <p>
        <span class="edit-defaults demographics-lob-default-name">{{ucmgData?.UCMG_Name}}</span>
      </p>
    </div>
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name mt-2">
      <span class="form-inline-new">
        <p class="lob-headers">Comments</p>
      </span>
      <span class="edit-defaults demographics-lob-default-name" >{{ucmgData?.comments}}</span>
    </div>
  </div>
  